import request from '@/utils/request'

export function previewSettlement() {
  return request({
    url: '/dispatcher/settlement/preview',
    method: 'get'
  })
}

export function previewDebtList() {
  return request({
    url: '/dispatcher/settlement/preview-debt',
    method: 'get'
  })
}

/**
 * 查看某写手未结明细
 * @param {Number} writer_id
 * @param {String} settlement_type 可选,筛选指定渠道
 */
export function getWriterUnsettledDetails(writer_id, settlement_type) {
  const params = { writer_id }
  if (settlement_type) params.settlement_type = settlement_type
  return request({
    url: '/dispatcher/settlement/detail',
    method: 'get',
    params
  })
}

export function getWriterPaymentInfo(writer_id) {
  return request({
    url: '/dispatcher/settlement/writer-payment-info',
    method: 'get',
    params: { writer_id }
  })
}

/**
 * 生成结款批次
 * @param {Number} writer_id
 * @param {Array<Number>} detail_ids
 */
export function createSettlementBatches(writer_id, detail_ids) {
  return request({
    url: '/dispatcher/settlement/batch/create',
    method: 'post',
    data: { writer_id, detail_ids }
  })
}

/**
 * 历史批次列表
 * @param {Object} params { status, writer_id, page, size }
 */
export function listSettlementBatches(params) {
  return request({
    url: '/dispatcher/settlement/batch/list',
    method: 'get',
    params
  })
}

export function getBatchDetail(id) {
  return request({
    url: '/dispatcher/settlement/batch/detail',
    method: 'get',
    params: { id }
  })
}

/**
 * 审核批次(支持单个或批量)
 * @param {Object} data { ids?, id?, approved, reject_reason? }
 */
export function auditBatch(data) {
  return request({
    url: '/dispatcher/settlement/batch/audit',
    method: 'post',
    data
  })
}